import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConstruction,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentShortTermAccommodationRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    price: validationRules.price,
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    buildingType: validationRules.buildingType,
    startRentalDate: validationRules.startRentalDateRequired,
    additionalCosts: validationRules.additionalCosts,
    deposit: validationRules.deposit,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  description: {
    ...defaultDescription,
    adFurnishingNote: validationRules.adFurnishingNote,
  },
  otherFacilities: {
    minRentalTime: validationRules.minRentalTime,
    maxRentalTime: validationRules.maxRentalTime,
    maxNumberOfPersons: validationRules.maxNumberOfPersons,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  construction: defaultConstruction,
  objectNumbers: {
    groupNumber: validationRules.groupNumber,
  },
  apiSearchData: defaultApiSearchData,
}
